import {FC, ReactNode, useEffect} from 'react';
import {IntlProvider} from 'react-intl';
import dayjs from 'dayjs';
import messagesEn from '../../lang/en.json';
import messageDe from '../../lang/de.json';
import messagesFr from '../../lang/fr.json';
import messagesUk from '../../lang/uk.json';
import {useAppDispatch, useAppSelector} from '../../app/hooks';
import {iamApi} from '../../api/iam';

interface AppIntlProviderProps {
    children: ReactNode;
}

interface LocaleProps {
    [key: string]: string;
}

interface MessagesProps {
    [key: string]: LocaleProps;
}

const messages: MessagesProps = {
    de: messageDe,
    fr: messagesFr,
    en: messagesEn,
    uk: messagesUk,
};

const AppIntlProvider: FC<AppIntlProviderProps> = ({children}) => {
    // catch locale
    const {lang} = useAppSelector((state) => state.common);
    const dispatch = useAppDispatch();

    // dictionary keys with translation

    useEffect(() => {
        document.documentElement.lang = lang;

        dayjs.locale(lang);

        // Permission text comes from the server, so switching language changes what these
        // endpoints answer for the same URL - and RTK Query, keying on the argument alone, had no
        // reason to ask again. Invalidated here rather than by adding the language to every query
        // argument: that is fourteen call sites today, and the fifteenth would be a localized endpoint
        // that silently kept showing the previous language.
        dispatch(iamApi.util.invalidateTags(['Catalog', 'Roles', 'Role']));
    }, [lang, dispatch]);

    return (
        <IntlProvider
            locale={lang}
            messages={messages[lang] ?? messages.en}
            defaultLocale="en"
        >
            {children}
        </IntlProvider>
    );
};

export default AppIntlProvider;
